import { render, staticRenderFns } from "./seamscroll.vue?vue&type=template&id=3aa725a5&scoped=true&"
import script from "./seamscroll.vue?vue&type=script&lang=js&"
export * from "./seamscroll.vue?vue&type=script&lang=js&"
import style0 from "./seamscroll.vue?vue&type=style&index=0&id=3aa725a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa725a5",
  null
  
)

export default component.exports